"use client";

import dynamic from "next/dynamic";
import type { HeroAgentClientProps } from "./HeroAgentClient";

const HeroAgentClientWrapper = dynamic(() => import("./HeroAgentClientWrapper").then(mod => mod.default));

export default function HeroAgentLazy(props: HeroAgentClientProps) {
  return <HeroAgentClientWrapper {...props} />;
}
